module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/local-market-stats-journey-line-c7acd41ada6b49abd150fbe4bc4b8186.svg";